/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { FC } from "react";

import { Button, Icon, Tooltip } from "@bookingcom/bui-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import flights_merch_toolkit_offer_pinning_v2 from "../../../../../utils/experiments/genius/flights_merch_toolkit_offer_pinning_v2";
import Frame from "../../../Frame";
import type { HighlightInfoTooltip } from "./types";

type Props = {
  infoTooltip: HighlightInfoTooltip;
};

const FlightCardGeniusHighlightTooltipWrapper: FC<Props> = ({ infoTooltip }) => {
  return (
    <Tooltip
      text={infoTooltip.content}
      onOpen={async () => {
        flights_merch_toolkit_offer_pinning_v2.goals.featured_info_displayed();
      }}
    >
      {(triggerAttributes) => (
        <Frame mr={2}>
          <Button
            variant="tertiary"
            attributes={{
              ...triggerAttributes
            }}
          >
            <Icon size="medium" svg={InfoSignIcon} />
          </Button>
        </Frame>
      )}
    </Tooltip>
  );
};

export default FlightCardGeniusHighlightTooltipWrapper;
